import React, {lazy, Suspense} from 'react';
import {createRoot} from 'react-dom/client';

let LoadableShoppingCartBanner = null;

// lazy() caches its result forever, so a failed load clears the wrapper to let the next mount retry.
function getLoadableShoppingCartBanner() {
  if (!LoadableShoppingCartBanner) {
    LoadableShoppingCartBanner = lazy(() =>
      import(/* webpackChunkName: "cartBanner" */ './ShoppingCartBanner').catch((error) => {
        console.error('Cart banner failed to load: ', error);
        LoadableShoppingCartBanner = null;
        return {default: () => null};
      }),
    );
  }
  return LoadableShoppingCartBanner;
}

let root = null;
let rootContainer = null;
let renderId = 0;

function getRoot() {
  if (!root) {
    const container = document.createElement('div');
    rootContainer = container;
    container.style.display = 'contents'; // keeps the root element out of layout
    (document.querySelector('#main-content') || document.body).prepend(container);
    root = createRoot(container);
  }
  return root;
}

/**
 * Renders the cart banner, creating its React root on first call.
 * Each call remounts the banner so its animation restarts.
 * @param {{lineItems: Array, itemsAdded: number, cartUrl: string}} props - Banner props.
 */
export function mountShoppingCartBanner(props) {
  renderId += 1;
  const LoadableBanner = getLoadableShoppingCartBanner();
  getRoot().render(
    <Suspense fallback={null}>
      <LoadableBanner key={renderId} {...props} />
    </Suspense>,
  );
}

/** Unmounts the banner and removes its container so the next mount starts clean. */
export function unmountShoppingCartBanner() {
  if (!root) return;
  root.unmount();
  rootContainer?.remove();
  root = null;
  rootContainer = null;
}
